import { Component } from '@angular/core';
import { IntegumentaryAssessment } from 'src/app/calvin-emr-shared/models/assessments/integumentary.model';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { EmrListComponent } from '../../../../shared/emr-list/emr-list.component';

@Component({
  selector: 'app-integumentary-info',
  template: `
    <div class="assessment-container">
      <assessment-row title="Skin Appearance" [historyMode]="true">
        <emr-list [list]="data().skinAppearance" emptyText="N/A"></emr-list>
        <p>{{ data().skinAppearanceComment }}</p>
      </assessment-row>
      <h2>Wounds</h2>
      <assessment-row title="Location" [historyMode]="true">
        <p>{{ data().location }}</p>
      </assessment-row>
      <assessment-row title="Staging" [historyMode]="true">
        <p>{{ data().staging }}</p>
      </assessment-row>
      <assessment-row title="Care" [historyMode]="true">
        <emr-list [list]="data().care" emptyText="None"></emr-list>
      </assessment-row>
      <assessment-row title="Other Findings" [historyMode]="true">
        <p>{{ data().otherFindings }}</p>
      </assessment-row>
    </div>
  `,
  styles: [`
    .assessment-container {
      padding-top: 1.5rem !important;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  `],
  standalone: true,
  imports: [AssessmentRowComponent, EmrListComponent],
})
export class IntegumentaryInfoComponent extends AssessmentInfoComponent<IntegumentaryAssessment> {}
